import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./cssFile/Components.css";

const Sidebar = () => {
  const location = useLocation();

  return (
    <div className="text-center">
      <ul
        className="navbar-nav sidebar sidebar-dark accordion topsie text-center"
        id="accordionSidebar"
      >
        <Link
          className="sidebar-brand d-flex align-items-center justify-content-center"
          to="/order"
        >
          <div className="sidebar-brand-text text-black-50 mx-3">ORDER</div>
        </Link>

        <hr className="sidebar-divider my-0" />
        <hr className="sidebar-divider" />

        <li className={`nav-item ${location.pathname === "/order" ? "active" : ""}`}>
          <Link className="nav-link" to="/order">
            <i className="fas fa-shopping-cart mr-2"></i>
            <span className="orders">Order</span>
          </Link>
        </li>

        <li
          className={`nav-item ${
            location.pathname === "/settings" ? "active" : ""
          }`}
        >
          <Link className="nav-link" to="/settings">
            <i className="fas fa-cog mr-2"></i>
            <span className="orders">Settings</span>
          </Link>
        </li>

        <li
          className={`nav-item ${
            location.pathname === "/" ? "active" : ""
          }`}
        >
          <Link className="nav-link" to="/">
            <i className="fas fa-sign-in-alt mr-2"></i>
            <span className="orders">Login</span>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
